import { render } from "./Encomenda.vue?vue&type=template&id=18e10556&scoped=true"
import script from "./Encomenda.vue?vue&type=script&lang=js"
export * from "./Encomenda.vue?vue&type=script&lang=js"

import "./Encomenda.vue?vue&type=style&index=0&id=18e10556&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e10556"]])

export default __exports__